"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAlphanumeric;

var _get = _interopRequireDefault(require("lodash/get"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BASE_REGEX = 'a-zA-Z0-9\'';
var BRACKET_REGEX = ' \\-()';
var JAPANESE_REGEX = '|ぁ-んァ-ン|一-龯';

function isAlphanumeric(val) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof val !== 'string') {
    return false;
  }

  var allowBrackets = (0, _get["default"])(options, 'allowBrackets', false);
  var allowJapaneseCharacters = (0, _get["default"])(options, 'allowJapaneseCharacters', false);
  var bracketRegex = allowBrackets ? BRACKET_REGEX : '';
  var japaneseRegex = allowJapaneseCharacters ? JAPANESE_REGEX : '';
  var specialCharacters = options.specialCharacters ? options.specialCharacters : '';
  var regex = new RegExp("^([".concat(BASE_REGEX).concat(japaneseRegex).concat(bracketRegex).concat(specialCharacters, " ]+)$"), 'i');
  return regex.test(val);
}